import React, { useEffect, useMemo, useState } from "react";
import { Radio, Modal, Typography } from "antd";

import PrimaryButton from "../Forms/PrimaryButton";
import DataTable from "../Tables/Datatable";
import SearchInput from "../Forms/SearchInput";
import Filters from "../Filters";
import ProductImageName from "../Layout/ProductImageName";
import Paragraph from "antd/es/typography/Paragraph";

const { Title } = Typography;

const getProductKey = (item) => item?.sort_no || item?.product_id || item?.id || item?.key;

export default function ProductLinkModal({
  open,
  isOpen,
  onClose,
  onSubmit,
  title = "Link Product",
  buttonTitle = "Confirm",
  loading = false,
  width = 420,
  currentItem = null,
  productData = [],
  selectedProducts = [],
  selectedproduct = null,
}) {
  const isModalOpen = typeof open === "boolean" ? open : isOpen;
  const [selectedItem, setSelectedItem] = useState(null);
  const [search, setSearch] = useState("");

  const { appliedFilters, ModalUI, FilterButton, resetFilters } = Filters({
    filters: [
      {
        type: "select",
        key: "clienttype",
        label: "Category",
        options: productData
          .map((item) => item?.clienttype)
          .filter((value, index, self) => value && self.indexOf(value) === index)
          .map((cat) => ({ label: cat, value: cat })),
        inputProps: { placeholder: "Select Category" },
      },
      {
        type: "select",
        key: "fabric_type",
        label: "Fabric Type",
        options: productData
          .map((item) => item?.fabric_type)
          .filter((value, index, self) => value && self.indexOf(value) === index)
          .map((cat) => ({ label: cat, value: cat })),
        inputProps: { placeholder: "Select Fabric Type" },
      },
    ],
  });

  useEffect(() => {
    if (isModalOpen) {
      let matchedProduct = null;

      if (selectedProducts?.length > 0) {
        // Handle legacy format: array of objects
        const incomingKey = getProductKey(selectedProducts[0]);
        matchedProduct = productData.find((p) => getProductKey(p) === incomingKey);
      } else if (selectedproduct) {
        // Handle new format: direct sort_no value
        matchedProduct = productData.find((p) => getProductKey(p) === selectedproduct);
      }

      setSelectedItem(matchedProduct || null);
      setSearch("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, productData, selectedproduct]);

  const filteredProducts = useMemo(() => {
    let data = [...productData];

    if (search) {
      const searchText = search.toLowerCase();
      data = data.filter((item) => (item?.quality_name || "").toLowerCase().includes(searchText));
    }

    if (Object.keys(appliedFilters).length) {
      data = data.filter((item) => Object.entries(appliedFilters).every(([key, value]) => !value || item[key] === value));
    }

    return data;
  }, [productData, search, appliedFilters]);

  const toggleItem = (record) => {
    if (!record) return;
    setSelectedItem(getProductKey(selectedItem) === getProductKey(record) ? null : record);
  };

  const columns = [
    {
      title: () => <span className="text-gray-900 text-left font-normal">Products</span>,
      dataIndex: "product",
      ellipsis: true,
      render: (item, record) => (
        <div className="flex gap-2 items-center">
          <ProductImageName
            img_url={record?.product_pic_url}
            img_alt={record?.quality_name}
            text={
              <div>
                <div className="font-semibold">{record?.quality_name}</div>
                <div className="text-xs text-gray-500">{record?.dyed_type}</div>
              </div>
            }
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <ModalUI />
      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={() => {
          onClose?.();
          resetFilters();
        }}
        width={width}
        className="form-css-2"
      >
        <div className="flex justify-between items-center">
          <Title level={2} className="text-3xl font-semibold text-gray-800 font-abhaya m-0">
            {title}
          </Title>
        </div>

        <Paragraph className="input-css !mb-3" level={5}>
          To - <span className="font-semibold">{currentItem?.short_name}</span>
        </Paragraph>

        <div className="flex gap-2 items-center mb-3">
          <SearchInput placeholder="Search for a product" value={search} onChange={(e) => setSearch(e.target.value)} />
          {/* <FilterButton /> */}
        </div>
        <DataTable
          rowKey={getProductKey}
          columns={columns}
          dataSource={filteredProducts}
          pagination={false}
          Showpagination={false}
          customEmptySection="Sorry, no products found"
          rootClassName="transparent-table"
          onRow={(record) => ({
            onClick: () => toggleItem(record),
            className: "cursor-pointer transition-colors",
          })}
          rowClassName={(record) => (getProductKey(record) === getProductKey(selectedItem) ? "bg-[#A334341A]" : "hover:bg-gray-50")}
        />
        <div className="flex justify-center mt-4">
          <PrimaryButton
            text={buttonTitle}
            loading={loading}
            disabled={!selectedItem}
            onClick={() => onSubmit?.(selectedItem?.sort_no)}
            className="w-[160px]"
          />
        </div>
      </Modal>
    </>
  );
}
